import styled from '@emotion/styled';

interface TabContentProps {
	open: boolean;
}
interface TabStickyProps {
	$isNotSticky?: boolean;
	isNotSticky?: boolean;
}

const stickyMode = ({ $isNotSticky, isNotSticky }: TabStickyProps) => $isNotSticky ?? isNotSticky;

export const TabListContainer = styled.nav<TabStickyProps>`
	position: ${(props) => (stickyMode(props) ? 'static' : 'sticky')};
	top: ${(props) => props.theme.heights.header};
	z-index: 9;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	gap: ${(props) => props.theme.scale.space2xs};
	max-width: ${(props) => props.theme.scale.contentMaxWidth};
	width: 100%;
	margin: 0 auto;
	padding: ${(props) => props.theme.scale.spaceMd} ${(props) => props.theme.scale.contentPaddingX};
	background: ${(props) => props.theme.ui.surface.page};
	border-bottom: 1px solid ${(props) => props.theme.ui.border.default};

	@media screen and (max-width: 1180px) {
		top: ${(props) => props.theme.heights.headerMobile};
	}
`;

export const TabListItem = styled.button`
	flex: 0 0 auto;
	margin: 0;
	padding: 0.6rem 1.2rem;
	border: none;
	border-radius: ${(props) => props.theme.effects.radiusFull};
	background: transparent;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 1.3;
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.tight};
	color: ${(props) => props.theme.ui.text.muted};
	cursor: pointer;
	transition:
		color ${(props) => props.theme.effects.transitionFast},
		background-color ${(props) => props.theme.effects.transitionFast};

	&:hover:not(.active) {
		color: ${(props) => props.theme.ui.text.secondary};
		background-color: ${(props) => props.theme.ui.interactive.hoverWash};
	}

	&.active {
		color: ${(props) => props.theme.ui.text.inverse};
		background-color: ${(props) => props.theme.ui.interactive.primary};
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
`;

export const DropdownContainer = styled.div<TabStickyProps>`
	width: 100%;
	max-width: ${(props) => props.theme.scale.contentMaxWidth};
	margin: 0 auto;
	padding: 0 ${(props) => props.theme.scale.contentPaddingX};
	position: ${(props) => (stickyMode(props) ? 'static' : 'sticky')};
	top: ${(props) => props.theme.heights.headerMobile};
	z-index: 9;
`;

export const DropdownWrapper = styled.div<TabStickyProps>`
	position: relative;
	display: flex;
	flex-direction: column;
	border-top: 1px solid
		${(props) => (stickyMode(props) ? props.theme.ui.border.default : 'transparent')};
`;

export const DropdownButton = styled.button`
	width: 100%;
	height: 4.4rem;
	padding: 0 ${(props) => props.theme.scale.spaceMd};
	background: ${(props) => props.theme.ui.surface.page};
	border: 1px solid ${(props) => props.theme.ui.border.default};
	border-radius: ${(props) => props.theme.effects.radiusMd};
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: ${(props) => props.theme.ui.text.primary};
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
`;

export const DropdownList = styled.ul<TabContentProps>`
	position: absolute;
	top: calc(100% + ${(props) => props.theme.scale.space2xs});
	width: 100%;
	background: ${(props) => props.theme.ui.surface.page};
	border: 1px solid ${(props) => props.theme.ui.border.default};
	border-radius: ${(props) => props.theme.effects.radiusMd};
	list-style: none;
	padding: ${(props) => props.theme.scale.space2xs};
	margin: 0;
	display: ${({ open }) => (open ? 'flex' : 'none')};
	flex-direction: column;
	gap: ${(props) => props.theme.scale.space3xs};
	overflow-y: auto;
	z-index: 10;
	box-shadow: ${(props) => props.theme.effects.shadowMd};
`;

export const DropdownItem = styled.li`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 1.3;
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.tight};
	padding: ${(props) => props.theme.scale.spaceSm} ${(props) => props.theme.scale.spaceMd};
	border-radius: ${(props) => props.theme.effects.radiusSm};
	color: ${(props) => props.theme.ui.text.primary};
	cursor: pointer;

	&:hover {
		color: ${(props) => props.theme.ui.text.accent};
		background-color: ${(props) => props.theme.ui.interactive.primaryMuted};
	}
`;

export const ArrowDown = styled.div<TabContentProps>`
	padding-left: ${(props) => props.theme.scale.space3xs};
	transition: transform ${(props) => props.theme.effects.transitionFast};
	${({ open }) => open && 'transform: rotate(180deg);'}
`;
